import React, { useContext } from "react";
import { ProduitInterface } from "dataProvider/Produit";
import { IntlContext } from "context";
import { Link } from "react-router-dom";
import Tooltip from "ui/Form/Element/Tooltip";
import { matomoPush } from "../helpers";

export interface VieProduitProps {
    produit: ProduitInterface | any;
}

const VieProduit: React.FC<VieProduitProps> = ({ produit }) => {
    const intl = useContext(IntlContext);

    const renderProduitLink = (produitId: string, title?: string, key?: any) => {
        const renderLink = (
            <Link
                key={key}
                to={`/produit/${produitId}`}
                className="cta--link"
                onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                    matomoPush([
                        ["setReferrerUrl", window.location.href],
                        ["setCustomUrl", `${window.location.href.replace(produit.id, produitId)}`],
                    ]);
                }}
            >
                {produitId}
            </Link>
        );

        if (!title) {
            return renderLink;
        }

        return (
            <Tooltip
                value={`${intl.formatMessage("produit.fiche.label.type_modification")} : ${title || ""}`}
                icon={{ visible: false }}
                className={"product-life__year__tooltip"}
                wrapper={{ identifier: ".product-life" }}
            >
                {renderLink}
            </Tooltip>
        );
    };

    // PRODUIT PERE
    let parentYear: any = null;
    let parentId: any = null;
    if (produit?.produit_parent) {
        const parent = produit?.produit_parent.split(";");
        if (parent.length === 2) {
            [parentId, parentYear] = parent;
        }
    } else if (Array.isArray(produit?.annee_prelevement) && produit?.annee_prelevement.length >= 2) {
        parentId = produit.id;
        parentYear = produit.annee_prelevement.slice(-2).shift();
    }

    // MODIFICATIONS PAR PRODUIT
    let modifications: HashMap<string[]> = {};
    if (Array.isArray(produit?.produit_modifications) && produit?.produit_modifications.length) {
        modifications = (produit?.produit_modifications as Array<any>).reduce((memo: HashMap<string[]>, modif: any) => {
            if (!memo[modif?.id_produit]) {
                memo[modif?.id_produit] = [];
            }
            memo[modif?.id_produit].push(modif?.type_modification_libel);
            return memo;
        }, {});
    }

    // PRODUITS DUPLICATIONS
    const sortAsc = (a: any, b: any) => (a < b ? -1 : a > b ? 1 : 0);
    const dupYear = produit?.derniere_anneeh;
    const dupProduitIds = Array.isArray(produit?.produit_duplication) ? produit?.produit_duplication.split("|") : [];
    dupProduitIds.push(produit.id);
    const renderProduitLinkList = (produitIds: any[]) => {
        return produitIds.sort(sortAsc).map((produitId: string, index: number) => {
            return (
                <React.Fragment key={index}>
                    {renderProduitLink(
                        produitId,
                        modifications[produitId] ? modifications[produitId].join(", ") : undefined
                    )}
                    <br />
                </React.Fragment>
            );
        });
    };

    // PRODUITS FILS
    let nextYear: number | null = null;
    let produitFils = [];
    if (produit?.derniere_anneeh && produit?.produit_fils) {
        produitFils = produit?.produit_fils.split("|").reduce((memo: HashMap<string[]>, fils: string) => {
            const filsData = fils.split(";");
            if (filsData.length === 2) {
                const fildId = filsData[0];
                const year = +filsData[1];
                if (!memo[year]) {
                    memo[year] = [];
                }
                memo[year].push(fildId);
                nextYear = !nextYear || (+produit.derniere_anneeh < year && year < nextYear) ? year : nextYear;
            }
            return memo;
        }, {});
    }

    const produitFilsIds = nextYear && produitFils[nextYear] ? produitFils[nextYear] : [];

    return (
        <React.Fragment>
            <h3 className="information__subtitle">{intl.formatMessage("produit.fiche.label.vie_produit")}</h3>
            <div className="product-life">
                <ul className="product-life__list">
                    {Boolean(parentId && parentYear) ? (
                        <li className="product-life__element">
                            <span className="product-life__label">{parentYear}</span>
                            <span className="product-life__year">
                                {renderProduitLink(
                                    parentId,
                                    modifications[parentId] ? modifications[parentId].join(", ") : undefined
                                )}
                            </span>
                        </li>
                    ) : (
                        <li className="product-life__element visibility-hidden"></li>
                    )}

                    {Boolean(dupYear && dupProduitIds.length) ? (
                        <li className="product-life__element">
                            <span className="product-life__label">{dupYear}</span>
                            <span className="product-life__year">{renderProduitLinkList(dupProduitIds)}</span>
                        </li>
                    ) : (
                        <li className="product-life__element visibility-hidden"></li>
                    )}

                    {Boolean(nextYear && produitFilsIds.length) ? (
                        <li className="product-life__element">
                            <span className="product-life__label">{nextYear}</span>
                            <span className="product-life__year">{renderProduitLinkList(produitFilsIds)}</span>
                        </li>
                    ) : (
                        <li className="product-life__element visibility-hidden"></li>
                    )}
                </ul>
            </div>
        </React.Fragment>
    );
};

export default VieProduit;
